import { getScreenSize } from "@utils/getScreenSize";
import { FC } from "react";
import { Link } from "react-router-dom";
import "swiper/css";
import { Swiper, SwiperSlide } from "swiper/react";
import styles from "./News.module.scss";

const News: FC = () => {
    const { isMobile } = getScreenSize();
    return (
        <section className={styles.news}>
            <div className={styles.headline}>
                <h2 className={styles.title}>News and updates</h2>
                <div className={styles.link}>
                    <Link to="/news">All news</Link>
                    <button>
                        <img width={12} height={12} src="/images/home/news/arrow.svg" alt="Go to the all news page" />
                    </button>
                </div>
            </div>
            {isMobile ? (
                <Swiper slidesPerView={1} spaceBetween={20} className={styles.items}>
                    {[0].map((i) => (
                        <SwiperSlide key={i}>
                            <Link to={`/news/{${i}}`} className={styles.item}>
                                <div className={styles.top}>
                                    <time dateTime="2024-10-04" className={styles.date}>
                                        04.10.2024
                                    </time>
                                    <button className={styles.button}>
                                        <img
                                            width={10}
                                            height={10}
                                            src="/images/home/news/arrow.svg"
                                            alt="Go to the news page"
                                        />
                                    </button>
                                </div>
                                <h3 className={styles.itemTitle}>Beta version</h3>
                                <p className={styles.description}>
                                    We welcome you to the beta version of the nestdex website!
                                </p>
                            </Link>
                        </SwiperSlide>
                    ))}
                </Swiper>
            ) : (
                <div className={styles.items}>
                    {[0].map((i) => (
                        <Link key={i} to={`/news/${i}`} className={styles.item}>
                            <div className={styles.top}>
                                <time dateTime="2024-10-04" className={styles.date}>
                                    04.10.2024
                                </time>
                                <button className={styles.button}>
                                    <img
                                        width={10}
                                        height={10}
                                        src="/images/home/news/arrow.svg"
                                        alt="Go to the news page"
                                    />
                                </button>
                            </div>
                            <h3 className={styles.itemTitle}>Beta version</h3>
                            <p className={styles.description}>
                                We welcome you to the beta version of the nestdex website!
                            </p>
                        </Link>
                    ))}
                </div>
            )}
        </section>
    );
};

export default News;
